"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

// global-error replaces the root layout, so globals.css is not available
// here. Styles are inline and mirror the Precision Luxe tokens.
const styles = {
  body: {
    margin: 0,
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "hsl(40 20% 98%)",
    color: "hsl(20 15% 12%)",
    fontFamily: "system-ui, sans-serif",
    padding: "24px",
  },
  card: {
    width: "100%",
    maxWidth: "480px",
    background: "#fff",
    border: "1px solid hsl(40 10% 88%)",
    borderRadius: "8px",
    padding: "32px",
    textAlign: "center" as const,
    boxShadow: "0 4px 12px hsl(20 15% 12% / 0.04)",
  },
  title: {
    fontFamily: "Georgia, serif",
    fontWeight: 400,
    fontSize: "28px",
    margin: "0 0 8px",
  },
  body_text: { color: "hsl(20 10% 42%)", margin: "0 0 24px", lineHeight: 1.6 },
  button: {
    background: "hsl(38 92% 50%)",
    color: "hsl(20 15% 8%)",
    border: 0,
    borderRadius: "6px",
    padding: "10px 20px",
    fontWeight: 600,
    cursor: "pointer",
  },
  link: {
    marginLeft: "12px",
    color: "hsl(20 15% 12%)",
    textDecoration: "underline",
    textUnderlineOffset: "3px",
  },
};

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body style={styles.body}>
        <main style={styles.card}>
          <h1 style={styles.title}>Kautious hit an unexpected error</h1>
          <p style={styles.body_text}>
            We have been notified. Try again, or return to the home page.
            {error.digest ? (
              <span
                style={{ display: "block", fontSize: "12px", marginTop: 8 }}
              >
                Reference {error.digest}
              </span>
            ) : null}
          </p>
          <button type="button" style={styles.button} onClick={() => reset()}>
            Try again
          </button>
          <a href="/" style={styles.link}>
            Go home
          </a>
        </main>
      </body>
    </html>
  );
}
